<template>
    <button type="button"
        class="downloaderGalleryLink bg-yellow-photo text-black border-black py-1 px-4 rounded"
        @click="handleSave">
        <span class="material-icons">download</span>
    </button>
</template>

<script>
import { saveImageFromUrl } from "@helpers/saveImage.helper.js";
import { mediaLogService } from "../../services/mediaLogService";

export default {
    name: "SaveImageButton",

    props: {
        imageUrl: {
            type: String,
            required: true
        },
        fileName: {
            type: String,
            default: "imagen.jpg"
        },
        albumCode: {
            type: String,
            default: null
        },
        parkId: {
            type: Number,
            default: null
        },
        mediaTotal: {
            type: Number,
            default: 0
        }
    },

    methods: {
        /**
         * Maneja la acción de guardar la imagen
         * @returns {void}
         */
        async handleSave() {
            saveImageFromUrl(this.imageUrl, {
                fileName: this.fileName,
                shareTitle: this.$t("gallery.save_image"),
                iosHelperText: this.$t("gallery.save_image_ios_helper")
            });
            await mediaLogService.logSingleDownload(this.$store, {
                code: this.albumCode,
                parkId: this.parkId,
                mediaTotal: this.mediaTotal
            });
        }
    }
};
</script>